<template>
  <div id="art-lessons" class="section">
    <v-container>
      <h1>Art Lessons</h1>
      <v-layout row wrap>
        <v-flex xs12 sm6 pl-3>
          <div class="title mb-3">Primary School Children</div>
            <p class="text-justify">Maria started teaching small groups of children privately since 1995, when she was a student of fine art and pedagogics. Her lessons combine improvised imaginative approach with a didactic method. Children from 4 years of age learn step-by-step how to observe and understand proportion and colour. She inspires aspiring artists of all ages through encouraging them to see their potential and through introducing them to the world of great paintings.</p>

            

          <p class="title">Current Art Classes:</p>

            <table class="mb-3">
              <thead>
                <tr>
                  <td></td>
                  <td><p class="font-weight-bold">Art School</p></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="font-italic">Days:</td>
                  <td class="larger">Wednesdays 4.30pm-5.45pm</td>
                </tr>
                  <td class="font-italic">Location:</td>
                  <td class="larger">The artist's studio at home</td>                 
               </tr>
                <tr>
                  <td class="font-italic">Starts at:</td>
                  <td class="larger">Afternoons</td>
                </tr>
                  <td class="font-italic">Audience:&nbsp;&nbsp;</td>
                  <td class="larger">Students aged 10+</td>                 
               </tr> 
              </tbody>              
            </table>
          <hr>
            <table class="my-3">
              <thead>
                <tr>
                  <td></td>
                  <td><p class="font-weight-bold">Art Lesssons (beginners-intermediates)</p></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="font-italic">Days:</td>
                  <td class="larger">Thursday evenings</td>
                </tr>
                  <td class="font-italic">Location:</td>
                  <td class="larger">Artist's Studio</td>                 
               </tr>
                <tr>
                  <td class="font-italic">Starts at:</td>
                  <td class="larger">8pm-9:30pm</td>
                </tr>
                  <td class="font-italic">Audience:&nbsp;&nbsp;</td>
                  <td class="larger">Adults</td>                 
               </tr> 
              </tbody>              
            </table>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <p class="title mb-3">GCSE, A-levels and adult tuition</p>
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/tuition2.png">
                <div class="img-thumbnail">
                  <img src="/img/lessons/tuition2_thumb.png" alt="Образец работы" class="img-fluid">              
                </div>
              </a>
            </v-flex>
            <v-flex xs12 sm8>
              <p class="text-justify">Maria is a successful tutor in helping young people with their drawing and painting for their art exams. Her lessons include anatomy studies, copying the "old master" drawings, basics of composition and good clear explanation about technique and colour.</p>

              <p class="text-justify">She is launching a new class based on drawing and painting from life in April 2012 at the Bath Artist Studios on Friday evenings 7pm-9pm.</p>
            </v-flex>            
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <p class="text-justify">The class will begin by covering the basics of drawing and painting techniques and will be beneficial not only to young people studying art, but also to anyone who wants to learn about still-life and portraiture. Come and try and you will want to paint and learn more!</p>
            </v-flex>
            <v-flex xs12 sm4 pl-3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/tuition1.png">
                <div class="img-thumbnail">
                  <img src="/img/lessons/tuition1_thumb.png" alt="Образец работы" class="img-fluid">              
                </div>
              </a>
            </v-flex>            
          </v-layout>          
        </v-flex>        
      </v-layout>

      <v-layout row my-3>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less7.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less7_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less1.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less1_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less2.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less2_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less4.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less4_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
      </v-layout>   

      <v-layout row mb-3>    
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less5.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less5_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less6.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less6_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>
        <v-flex xs12 sm3>
              <a data-fancybox="gallery" data-type="image" href="/img/lessons/less3.jpg">
                <div class="img-thumbnail">
                  <img src="/img/lessons/less3_thumb.jpg" alt="Образец работы" class="img-fluid">              
                </div>
              </a>          
        </v-flex>                                        
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'ArtLessons',
      data: ()=>({

      })
  }
</script>


<style>
  #art-lessons .img-left {
    float: left;
    padding: 0 5px;
    border-right: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-right: 15px;
  }
  #art-lessons .img-right {
    float: right;
    padding: 0 5px;
    border-left: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-left: 15px;
  }
  #art-lessons .larger {
    font-size: larger;
    font-weight: 400;
  }
  #art-lessons .img-thumbnail {
    padding: 5px;
    border: 1px solid #ccc;
    float: left;
    border-radius: 5px;
  }
</style>